export const environment = {
  production: false,
  baseUrl: 'https://devapi.anikinitek.com/assetmgmtdev/',
  cid: 1793704350835,
  razorpayKey: 'rzp_test_zOmYjCNx9hxf8X',

};

